import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

interface HamburgerIconProps {
  isOpen: boolean;
  onClick: () => void;
}

export const HamburgerIcon: React.FC<HamburgerIconProps> = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-[40px] h-[40px] flex justify-center items-center cursor-pointer bg-transparent border-none outline-none focus:outline-none active:outline-none hover:outline-none active:border-none hover:border-none active:bg-transparent hover:bg-transparent relative"
      style={{ 
        background: 'transparent',
        border: 'none',
        outline: 'none'
      }}
      aria-label="Menu"
    >
      <MenuIcon 
        className="absolute"
        style={{ 
          fontSize: '40px', 
          color: '#FFFFFF',
          opacity: isOpen ? 0 : 1,
          transform: isOpen ? 'rotate(90deg) scale(0.8)' : 'rotate(0deg) scale(1)',
          transition: 'opacity 300ms ease-in-out, transform 300ms ease-in-out'
        }}
      />
      <CloseIcon 
        className="absolute"
        style={{ 
          fontSize: '40px', 
          color: '#FFFFFF',
          opacity: isOpen ? 1 : 0,
          transform: isOpen ? 'rotate(0deg) scale(1)' : 'rotate(-90deg) scale(0.8)',
          transition: 'opacity 300ms ease-in-out, transform 300ms ease-in-out'
        }}
      />
    </button>
  );
};
